module.exports = __webpack_public_path__ + "static/media/methodology_bg.626b1062.jpg";